// JavaScript Document
$(document).ready(function() {
	// navigation
	document.addEventListener('click',function(e){
		// Hamburger menu
		if(e.target.classList.contains('hamburger-toggle')){
		  e.target.children[0].classList.toggle('active');
		}
	});

	$(".navbar-toggler").click(function(){
		$("html").toggleClass("navigation-menu-open overflow-hidden");
	});

	// navigation



	// our-training-stories-carousel
	var swipertraining = new Swiper(".our-training-stories-carousel", {
		slidesPerView: 2,
        spaceBetween: 16,
		loop: true,
	slideToClickedSlide: true,
    lazyLoading: true,
    lazyLoadingInPrevNext: true,
    watchSlidesProgress: true,
    watchSlidesVisibility: true,
	});
	// our-training-stories-carousel

	// revolutionize-carousel
	var swiperrevolutionize = new Swiper(".revolutionize-carousel", {
		slidesPerView: 1,
        // spaceBetween: 12,
		loop: true,
       pagination: {
        el: '.revolutionize-carousel .swiper-pagination',
        clickable: true,
      },
	
	});

	// revolutionize-carousel


	// every-field-goal-carousel


	// franchise-logos-carousel
	var swiperlogos = new Swiper(".franchise-logos-carousel", {
		slidesPerView: 6,
        spaceBetween: 15,
loop: true,
 autoplay: {
        delay: 12500,
        disableOnInteraction: false,
      },
		breakpoints: {
			320: {
				slidesPerView: 4,
				spaceBetween: 8,
				loop: true,
			},
			375: {
				slidesPerView: 4,
				spaceBetween: 8,
				loop: true,
			},
			576: {
				slidesPerView: 6,
				spaceBetween: 15,
				loop: false,
			},
		},
	});
	// franchise-logos-carousel

	// take-it-experts-carousel


  	var swiper06 = new Swiper(".swiper.warrenty-guarantee-left", {
		slidesPerView: 'auto',
     	spaceBetween: 15,
   loop: true,
autoplay: {
    delay: 1,
    disableOnInteraction: true
  },
  freeMode: true,
  speed: 5000,
      pagination: {
        el: '.swiper.warrenty-guarantee-left .swiper-pagination',
        clickable: true,
      },
	});
  
	var swiperexperts = new Swiper(".take-it-experts-carousel", {
		slidesPerView: 1,
     	spaceBetween: 8,
		centeredSlides: true,
		loop: true,
    lazyLoading: true,
 initialSlide: 1,
    lazyLoadingInPrevNext: true,
    watchSlidesProgress: true,
    watchSlidesVisibility: true,
		// breakpoints: {
		// 	500: {
		// 	  slidesPerView: 1
		// 	},
		// 	700: {
		// 	  slidesPerView: 1.5
		// 	}
		// }
		pagination: {
			el: ".take-it-experts-section .swiper-pagination",
			clickable: true,
		},
	});
	// take-it-experts-carousel

	// reviews-counting-carousel
	var swiper6 = new Swiper(".reviews-counting-carousel", {
		slidesPerView: 4,
        spaceBetween: 24,
        centeredSlides: true,
		loop: true,

		breakpoints: {
			320: {
				slidesPerView: 1,
				spaceBetween: 0,
			},
			375: {
				slidesPerView: 1.5,
				spaceBetween: 8,
			},
			576: {
				slidesPerView: 2,
				spaceBetween: 12,
			},
			768: {
				spaceBetween: 24,
			},
			1920: {
				slidesPerView: 2,
			},
			2400: {
				slidesPerView: 3,
			}
		},
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
	});
	// reviews-counting-carousel

	// our-training-service videos
	// $(".our-training-storie-block").mouseenter(function(){
	// 	$(".our-training-storie-block").removeClass("active");
	// 	$(this).addClass("active");
	// 	$(this).find(".training-image video")[0].play();
	// });

	// $(".our-training-storie-block").mouseleave(function(){
	// 	$(this).removeClass("active");
	// 	$(this).find(".training-image video")[0].pause();
	// });

  
   var swiper07 = new Swiper('.common-your-training-text .swiper-container', {
      direction: 'vertical',
 loop: true,
noSwiping: true,
allowTouchMove: false,
   autoplay: {
        delay: 1200,
        disableOnInteraction: true,
      },
      pagination: {
        el: '.meet-our-community-section  .swiper-pagination',
        clickable: false,
      },
    });
  
  
	$(".our-training-storie-block").each(function () {
		$(this).on("mouseover", function (e) {
			$(this).addClass("active");
			$(this).find('.training-image video')[0].play();
		});
		$(this).on("mouseout", function (e) {
			$(this).removeClass("active");
			$(this).find('.training-image video')[0].pause();
		});
	});
	// our-training-service videos

	// accordion toggle
	$(".every-field-goal-accordion .accordion-item .accordion-button").click(function(){
		$(".every-field-goal-accordion .accordion-item").removeClass("accordion-item-active");
		if($(this).hasClass("collapsed")) {
			$(this).parent().parent().removeClass("accordion-item-active");
		} else {
			$(this).parent().parent().addClass("accordion-item-active");
		}
	});
	// accordion toggle


});


	// like-pros-carousel
	var swiper8 = new Swiper(".like-pros-carousel", {
		slidesPerView: 8,
        spaceBetween: 15,
		breakpoints: {
			320: {
				slidesPerView: 4,
				spaceBetween: 8,
				loop: true,
			},
			375: {
				slidesPerView: 4,
				spaceBetween: 8,
				loop: true,
			},
			768: {
				slidesPerView: 6,
				spaceBetween: 15,
				loop: false,
			},
			1400: {
				slidesPerView: 8,
				spaceBetween: 15,
				loop: false,
			},
		},
	});
	// like-pros-carousel

	// raise-up-pods-carousel
	// var swiper9 = new Swiper(".raise-up-pods-carousel", {
	var raise_up_pods_slider = new Swiper(".raise-up-pods-carousel", {
		slidesPerView: 1,
        spaceBetween: 8,
	centeredSlides: true,
	 initialSlide: 1,
    lazyLoading: true,
    lazyLoadingInPrevNext: true,
    watchSlidesProgress: true,
    watchSlidesVisibility: true,
		pagination: {
			el: ".raise-up-pods-carouse .swiper-pagination",
			clickable: true,
		},
	});
	// var swiper10 = new Swiper(".raise-up-pods-items-carousel", {
	var raise_up_pods_items_slider = new Swiper(".raise-up-pods-items-carousel", {
		// enabled: false,
  initialSlide: 1,
		slideToClickedSlide: true,
		pagination: {
			el: ".raise-up-pods-carousel .swiper-pagination",
			clickable: true,
		},
  
	});
	// raise-up-pods-carousel

	raise_up_pods_items_slider.controller.control = raise_up_pods_slider;
	raise_up_pods_slider.controller.control = raise_up_pods_items_slider;


  
  	// our-training-service videos
	$(".our-training-storie-block").each(function () {
		$(this).on("mouseover", function (e) {
			$(this).addClass("active");
			$(this).find('.training-image video')[0].play();
		});
		$(this).on("mouseout", function (e) {
			$(this).removeClass("active");
			$(this).find('.training-image video')[0].pause();
		});
	});
	// our-training-service videos

	// accordion toggle
	$(".every-field-goal-accordion .accordion-item .accordion-button").click(function(){
		$(".every-field-goal-accordion .accordion-item").removeClass("accordion-item-active");
		if($(this).hasClass("collapsed")) {
			$(this).parent().parent().removeClass("accordion-item-active");
		} else {
			$(this).parent().parent().addClass("accordion-item-active");
		}
	});


	// like-pros-carousel
	var swiper8 = new Swiper(".like-pros-carousel", {
		slidesPerView: 8,
        spaceBetween: 15,
		breakpoints: {
			320: {
				slidesPerView: 4,
				spaceBetween: 8,
				loop: true,
			},
			375: {
				slidesPerView: 4,
				spaceBetween: 8,
				loop: true,
			},
			768: {
				slidesPerView: 6,
				spaceBetween: 15,
				loop: false,
			},
			1400: {
				slidesPerView: 8,
				spaceBetween: 15,
				loop: false,
			},
		},
	});
	// like-pros-carousel

	


	// bettleshipSlider
	$(".rising-blazepers-carousel").ticker({
        speed: 00,
        pauseOnHover: 1,
        item: ".rising-blazepers-item",
     
    });
	// bettleshipSlider
  
